import { useEffect } from "react";
import StepComplete from "../../../components/common/stepComplete/StepComplete";
import AppHeader from "../../../components/common/appHeader/AppHeader";
import { UserContext } from "./../../../App";
import { useDispatch } from "react-redux";
import { setIsComplete } from "@src/@slice/recommendHallSlice";

const Complete = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setIsComplete({ bool: true }));
  }, []);
  const linkChat = () => {
    window.location.href = "h2mwbell://chat";
  };
  return (
    <div>
      <AppHeader type="nonStack" actionItems={[{ name: "close" }]} />
      <StepComplete
        title={`짝짝짝!
				웨딩홀 추천 요청이 접수되었습니다.`}
        text={`1:1 맞춤형 웨딩홀 추천 리스트를 곧 보내드릴게요! 
          조금만 기다려 주세요.

          추천 리스트는 카카오 알림톡과 웨딩북 앱 채팅창에서 확인할 수 있어요.`}
      />
      <UserContext.Consumer>
        {(user) => (
          <>
            {user.me && (
              <button className="btn btn-red500 btn-fixed-circle" onClick={linkChat}>
                채팅 확인
              </button>
            )}
          </>
        )}
      </UserContext.Consumer>
    </div>
  );
};

export default Complete;
